'use client';

import Image from 'next/image';
import Marquee from 'react-fast-marquee';
import type { JSX } from 'react';

interface LogoAsset {
  readonly filename: string;
  readonly alt: string;
  readonly width: number;
  readonly height: number;
}

const logoAssets: readonly LogoAsset[] = [
  {
    filename: '6b86f51d0a7f554e1223fdc6f5196ee9a74792d1.png',
    alt: 'Specto logo',
    width: 120,
    height: 60,
  },
  {
    filename: 'logo 1 (2).svg',
    alt: 'Simplo logo',
    width: 120,
    height: 60,
  },
  {
    filename: 'logo-horizontal.svg',
    alt: 'Attent logo',
    width: 120,
    height: 60,
  },
  {
    filename: 'Wedesign.svg',
    alt: 'Wedesign logo',
    width: 120,
    height: 60,
  },
  {
    filename: 'a20d2ad1d648cea98c33b6c1abad0dace57c6ff8.png',
    alt: 'Profi logo',
    width: 120,
    height: 60,
  },
] as const;

export default function TopClientsSliderSection(): JSX.Element {
  return (
    <section
      className="bg-[#FDF5DE] py-[21px]"
      aria-label="Nasi klienci"
    >
      <div className="h-[86px] w-full">
        <Marquee
          pauseOnHover
          speed={40}
          gradient={false}
          className="h-full"
          autoFill
        >
          {logoAssets.map(({ filename, alt, width, height }) => (
            <div
              key={filename}
              className="flex h-[86px] items-center mr-[80px]"
            >
              <Image
                src={`/assets/top-slider/${encodeURIComponent(filename)}`}
                alt={alt}
                width={width}
                height={height}
                loading="lazy"
                className="max-h-full w-auto object-contain"
              />
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
